angular.module('security.login', ['security.login.form', 'security.login.toolbar']);


// WEBPACK FOOTER //
// ./client/src/common/security/login/login.js